function getRandomCharacter(characters) {
    // Create a typed array to hold a single random integer
    const randomValues = new Uint32Array(1);
    // Get a cryptographically secure random value
    window.crypto.getRandomValues(randomValues);
    // Calculate a random index
    const randomIndex = randomValues[0] % characters.length; // Ensure the index is within bounds
    return characters.charAt(randomIndex);
}

export const generateRandomString = (length) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += getRandomCharacter(characters)
    }
    return result;
};


export const generateSecureRandomNumber = () => {
    const array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    return array[0] % 90000 + 10000; // Generates a random number between 10000 and 99999
}